import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../base-query';
import { serializeQueryArgs } from '../serialize-query-args';

export const PROMO_CODES_TAGS = Object.freeze({
  PROMO_CODES: 'promo_codes',
});

export const promoCodesApiSlice = createApi({
  reducerPath: 'promoCodesApiSlice',
  baseQuery,
  tagTypes: Object.values(PROMO_CODES_TAGS),
  endpoints: (builder) => ({
    // `companyId` is not sent (the API client scopes by its headers); it keys the cache per company.
    getPromoCodes: builder.query({
      query: ({ apiManager, params }) => apiManager.get(params),
      providesTags: [PROMO_CODES_TAGS.PROMO_CODES],
    }),
    getPromoCode: builder.query({
      query: ({ apiManager, id }) => apiManager.show(id),
    }),
    uploadPromoCodeImage: builder.mutation({
      query: ({ apiManager, id, data }) => apiManager.uploadImage(id, data),
      invalidatesTags: (_, error) => {
        if (error) {
          return [];
        }

        return [PROMO_CODES_TAGS.PROMO_CODES];
      },
    }),
    deletePromoCodeImage: builder.mutation({
      query: ({ apiManager, id, data }) => apiManager.deleteImage(id, data),
      invalidatesTags: (_, error) => {
        if (error) {
          return [];
        }

        return [PROMO_CODES_TAGS.PROMO_CODES];
      },
    }),
    generatePromoCodeImage: builder.mutation({
      query: ({ apiManager, id }) => apiManager.generateImage(id),
    }),
  }),
  serializeQueryArgs,
});

export const {
  useGetPromoCodesQuery,
  useGetPromoCodeQuery,
  useUploadPromoCodeImageMutation,
  useDeletePromoCodeImageMutation,
  useGeneratePromoCodeImageMutation,
} = promoCodesApiSlice;
